import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import "./Slider.css";

import hero1 from "../../assets/images/carroussel1.png";
import hero2 from "../../assets/images/carroussel2.png";
import hero3 from "../../assets/images/carroussel3.png";

const DURATION = 4000;

const slides = [
  {
    img: hero1,
    title: "Votre vitrine digitale, livree en 7 jours",
    subtitle: "Sites web professionnels pour les entrepreneurs et PME de Cote d'Ivoire. A partir de 150 000 FCFA.",
  },
  {
    img: hero2,
    title: "Vendez en ligne avec Orange Money et Wave",
    subtitle: "Boutiques e-commerce sur mesure. Vos clients paient en quelques secondes, sans carte bancaire.",
  },
  {
    img: hero3,
    title: "Une application mobile pour votre metier",
    subtitle: "iOS et Android depuis un seul code source. Concu pour les utilisateurs ivoiriens.",
  },
];

export default function Slider() {
  const [index, setIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const rafRef = useRef(null);

  const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);
  const next = useCallback(() => setIndex((i) => (i + 1) % slides.length), []);

  useEffect(() => {
    const timeout = setTimeout(next, DURATION);
    return () => clearTimeout(timeout);
  }, [index, next]);

  useEffect(() => {
    setProgress(0);
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(((now - start) / DURATION) * 100, 100);
      setProgress(p);
      if (p < 100) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [index]);

  return (
    <div className="slider">
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`slider-bg${i === index ? " active" : ""}`}
          style={{ backgroundImage: `url(${slide.img})` }}
        />
      ))}
      <div className="slider-bg-overlay" />

      <div className="slider-overlay" key={index}>
        <h2>{slides[index].title}</h2>
        <p>{slides[index].subtitle}</p>
        <div className="slider-actions">
          <Link to="/devis" className="slider-cta">Demander un devis</Link>
          <Link to="/tarifs" className="slider-cta-secondary">Voir les tarifs</Link>
        </div>
      </div>

      <button className="slider-arrow left" onClick={prev} aria-label="Précédent">‹</button>
      <button className="slider-arrow right" onClick={next} aria-label="Suivant">›</button>

      <div className="slider-footer">
        <div className="slider-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`slider-dot${i === index ? " active" : ""}`}
              onClick={() => setIndex(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
        <div className="slider-progress-track">
          <div className="slider-progress-bar" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
}
